module.exports = __webpack_public_path__ + "8daa650922005cfa64e49674866864b7.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/prospective.png
// module id = 562
// module chunks = 0